/* QUIETUDE product page behaviour.
   The page is split into sections, each rendering its own .mm wrapper, so
   everything below binds from the document rather than a single root, and
   guards against running twice when several sections load the same asset.
   Everything degrades without JS: the buy form posts to /cart/add normally,
   every accordion panel is reachable, and the mobile gallery is a plain
   scroll rail that works on its own. */
(function () {
  if (window.__qtPdpBound) return;
  window.__qtPdpBound = true;

  var reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* ---- accordion motion ----
     A panel that appears reads as a glitch; a panel that unfolds reads as
     material. So the height is measured and animated rather than toggled.
     Two eases, not one: opening leaves quickly and settles slowly, the way
     something with weight comes to rest, while closing is a touch faster and
     more even — nobody wants to sit and watch what they just dismissed. */
  var EASE_OPEN  = 'cubic-bezier(.22,.72,.24,1)';
  var EASE_CLOSE = 'cubic-bezier(.45,.05,.35,1)';

  /* Paced by distance: a two-line panel has no business taking as long as a
     full description. Bounded at both ends so nothing feels clipped or slow. */
  function slideMs(px, opening) {
    var d = 200 + Math.min(px, 560) * 0.42;
    return Math.round(opening ? Math.min(d, 520) : Math.min(d * 0.82, 420));
  }

  function stopMotion(panel) {
    if (panel.__qtSlide) { panel.__qtSlide.cancel(); panel.__qtSlide = null; }
    (panel.__qtKids || []).forEach(function (a) { a.cancel(); });
    panel.__qtKids = [];
  }

  function setAccordion(item, open) {
    var q = item.querySelector('.mm-q');
    var panel = item.querySelector('.mm-a');
    if (!panel) return;

    item.classList.toggle('open', open);
    if (q) q.setAttribute('aria-expanded', open ? 'true' : 'false');

    /* Read where the panel actually is before cancelling anything, so a click
       that lands mid-animation carries on from the height on screen instead
       of snapping back to a state nobody saw. */
    var closed  = panel.hidden;
    var kids    = [].slice.call(panel.children);
    var kidFrom = kids.map(function (kid) {
      return closed ? 0 : parseFloat(getComputedStyle(kid).opacity);
    });
    var fromH   = closed ? 0 : panel.getBoundingClientRect().height;
    var fromPad = closed ? '0px' : getComputedStyle(panel).paddingBottom;
    stopMotion(panel);

    if (reduced || !panel.animate) {
      panel.hidden = !open;
      return;
    }

    /* Shown while it animates; `hidden` goes back on at the end, where the
       semantics assistive tech and the no-JS fallback both rely on it live. */
    panel.hidden = false;
    var toH = 0, toPad = '0px';
    if (open) {
      toH = panel.getBoundingClientRect().height;
      toPad = getComputedStyle(panel).paddingBottom;
    }

    var ms = slideMs(Math.abs(toH - fromH), open);
    panel.style.overflow = 'hidden';
    panel.style.willChange = 'height';
    panel.__qtSlide = panel.animate(
      [{ height: fromH + 'px', paddingBottom: fromPad },
       { height: toH + 'px',   paddingBottom: toPad }],
      { duration: ms, easing: open ? EASE_OPEN : EASE_CLOSE, fill: 'both' }
    );
    panel.__qtSlide.onfinish = function () {
      stopMotion(panel);                 /* drops the fill, back to auto height */
      panel.style.overflow = '';
      panel.style.willChange = '';
      panel.hidden = !open;
    };

    /* The text trails the edge by a beat and lifts into place. That lag is
       the whole difference between a panel unfolding and a blind going up. */
    panel.__qtKids = kids.map(function (kid, i) {
      var lead = open ? Math.min(80 + i * 55, ms * 0.45) : 0;
      return kid.animate(
        open ? [{ opacity: kidFrom[i], transform: 'translateY(7px)' },
                { opacity: 1, transform: 'none' }]
             : [{ opacity: kidFrom[i] }, { opacity: 0 }],
        { duration: open ? Math.max(ms - lead, 180) : Math.round(ms * 0.6),
          delay: lead, easing: open ? EASE_OPEN : 'linear', fill: 'both' }
      );
    });
  }

  function init(scope) {
    /* ---- promo bar ---- */
    scope.querySelectorAll('.mm-promo[data-promo]').forEach(function (bar) {
      if (bar.dataset.bound) return;
      bar.dataset.bound = '1';

      var msgs;
      try { msgs = JSON.parse(bar.getAttribute('data-promo') || '[]'); } catch (e) { msgs = []; }
      var label = bar.querySelector('p');
      var i = 0;

      function show(n) {
        if (!msgs.length || !label) return;
        i = ((n % msgs.length) + msgs.length) % msgs.length;
        label.textContent = msgs[i];
      }
      bar.querySelectorAll('[data-promo-dir]').forEach(function (b) {
        b.addEventListener('click', function () { show(i + parseInt(b.getAttribute('data-promo-dir'), 10)); });
      });

      var every = parseInt(bar.getAttribute('data-rotate') || '0', 10);
      if (msgs.length > 1 && every > 0 && !reduced) {
        setInterval(function () { show(i + 1); }, every * 1000);
      }

      /* countdown to a real date; hides itself once the date has passed */
      var until = bar.getAttribute('data-until');
      var out = bar.querySelector('[data-countdown]');
      if (until && out) {
        var end = new Date(until.replace(' ', 'T')).getTime();
        if (isNaN(end)) { out.remove(); return; }
        var tick = function () {
          var left = end - Date.now();
          if (left <= 0) { out.remove(); clearInterval(timer); return; }
          var h = Math.floor(left / 3600000);
          var m = Math.floor((left % 3600000) / 60000);
          var s = Math.floor((left % 60000) / 1000);
          out.textContent = h + 'h ' + ('0' + m).slice(-2) + 'm ' + ('0' + s).slice(-2) + 's';
        };
        tick();
        var timer = setInterval(tick, 1000);
      }
    });

    /* ---- gallery ----
       One control surface for two gestures: thumbs on desktop, a snap rail
       with dots under 760px. select() drives both so they never disagree. */
    scope.querySelectorAll('.mm-gallery').forEach(function (gallery) {
      if (gallery.dataset.bound) return;
      gallery.dataset.bound = '1';

      var stage  = gallery.querySelector('[data-stage]');
      var slides = [].slice.call(gallery.querySelectorAll('[data-slide]'));
      var thumbs = [].slice.call(gallery.querySelectorAll('[data-thumb]'));
      var dots   = [].slice.call(gallery.querySelectorAll('[data-dot]'));
      if (!stage || slides.length < 2) return;

      var isRail = function () { return getComputedStyle(stage).overflowX !== 'hidden'; };

      function mark(index) {
        slides.forEach(function (s, i) { s.classList.toggle('on', i === index); });
        thumbs.forEach(function (t, i) { t.classList.toggle('on', i === index); });
        dots.forEach(function (d, i) {
          d.classList.toggle('on', i === index);
          d.setAttribute('aria-selected', i === index ? 'true' : 'false');
        });
      }

      function select(index, scrollTo) {
        if (index < 0 || index >= slides.length) return;
        mark(index);
        if (scrollTo && isRail()) {
          stage.scrollTo({ left: slides[index].offsetLeft - stage.offsetLeft,
                           behavior: reduced ? 'auto' : 'smooth' });
        }
      }

      thumbs.forEach(function (t, i) { t.addEventListener('click', function () { select(i, false); }); });
      dots.forEach(function (d, i) { d.addEventListener('click', function () { select(i, true); }); });

      /* Follow the rail while the finger drags it. */
      var raf = null;
      stage.addEventListener('scroll', function () {
        if (raf) return;
        raf = requestAnimationFrame(function () {
          raf = null;
          if (!isRail()) return;
          var mid = stage.scrollLeft + stage.clientWidth / 2;
          var best = 0, bestGap = Infinity;
          slides.forEach(function (s, i) {
            var gap = Math.abs(s.offsetLeft - stage.offsetLeft + s.offsetWidth / 2 - mid);
            if (gap < bestGap) { bestGap = gap; best = i; }
          });
          mark(best);
        });
      }, { passive: true });
    });

    /* ---- accordions ---- */
    scope.querySelectorAll('.mm-q').forEach(function (q) {
      if (q.dataset.bound) return;
      q.dataset.bound = '1';
      var item = q.closest('.mm-item');
      if (!item) return;
      q.setAttribute('aria-expanded', item.classList.contains('open') ? 'true' : 'false');
      q.addEventListener('click', function () {
        setAccordion(item, !item.classList.contains('open'));
      });
    });

    /* ---- variants ---- */
    scope.querySelectorAll('[data-variant]').forEach(function (pill) {
      if (pill.dataset.bound) return;
      pill.dataset.bound = '1';
      pill.addEventListener('click', function () {
        if (pill.disabled) return;
        var row = pill.closest('.mm-vrow');
        var panel = pill.closest('.mm-panel') || document;
        if (row) row.querySelectorAll('[data-variant]').forEach(function (p) { p.classList.remove('on'); });
        pill.classList.add('on');

        var idField = panel.querySelector('[data-variant-id]');
        var nowEl = panel.querySelector('.mm-now');
        var wasEl = panel.querySelector('.mm-was');
        var valEl = panel.querySelector('[data-variant-label]');

        if (idField) idField.value = pill.getAttribute('data-variant');
        if (nowEl) nowEl.textContent = pill.getAttribute('data-price') || nowEl.textContent;
        var was = pill.getAttribute('data-compare');
        if (wasEl) { wasEl.textContent = was || ''; wasEl.style.display = was ? '' : 'none'; }
        if (valEl) valEl.textContent = pill.getAttribute('data-title') || '';
      });
    });

    /* ---- add to cart ---- */
    scope.querySelectorAll('[data-add-form]').forEach(function (form) {
      if (form.dataset.bound) return;
      form.dataset.bound = '1';
      form.addEventListener('submit', function (e) {
        if (!window.fetch) return;              /* let the normal POST happen */
        e.preventDefault();
        var btn = form.querySelector('.mm-cta');
        var original = btn ? btn.textContent.trim() : '';
        if (btn) { btn.disabled = true; btn.textContent = 'Ajout…'; }

        /* ETHYLGO : le bloc lot (eth-pack.js) pose son choix en JSON sur le
           formulaire ; /cart/add.js prend alors toute la liste d'un coup. */
        var packed = form.dataset.ethItems;
        var req = packed
          ? { method: 'POST', headers: { 'Content-Type': 'application/json' },
              body: JSON.stringify({ items: JSON.parse(packed) }) }
          : { method: 'POST', body: new FormData(form) };

        fetch('/cart/add.js', req)
          .then(function (r) { return r.json().then(function (j) { return { ok: r.ok, j: j }; }); })
          .then(function (res) {
            if (!res.ok) throw new Error(res.j.description || 'Ajout impossible');
            if (btn) btn.textContent = 'Ajouté';
            return fetch('/cart.js').then(function (r) { return r.json(); });
          })
          .then(function (cart) {
            document.querySelectorAll('.mm-count, .cart-count').forEach(function (c) { c.textContent = cart.item_count; });
            if (typeof window.qtOpenCart === 'function') window.qtOpenCart(cart);
          })
          .catch(function (err) { if (btn) btn.textContent = String(err.message).slice(0, 40); })
          .finally(function () {
            setTimeout(function () { if (btn) { btn.disabled = false; btn.textContent = original; } }, 1600);
          });
      });
    });
  }

  init(document);

  /* Theme editor re-renders a section in place — rebind what it just inserted. */
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
  document.addEventListener('shopify:block:select', function (e) {
    var item = e.target.querySelector('.mm-item') || e.target.closest('.mm-item');
    if (item && !item.classList.contains('open')) setAccordion(item, true);
  });
})();